import { Link } from "react-router-dom";

const highlights = [
  {
    icon: "ri-compass-3-line",
    title: "多元话题",
    desc: "从兴趣圈子到专业讨论，总有一个话题能让你开口。",
  },
  {
    icon: "ri-chat-smile-2-line",
    title: "轻松交流",
    desc: "简洁的互动体验，让每一次回应都自然又顺畅。",
  },
  {
    icon: "ri-user-heart-line",
    title: "真诚连接",
    desc: "在这里认识同好，也认识那些和你想法接近的人。",
  },
  {
    icon: "ri-sparkling-2-line",
    title: "精选推荐",
    desc: "每日精选优质内容，帮你把时间花在真正值得的阅读上。",
  },
];

export default function AboutIntro() {
  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-14 items-center">
        <div>
          <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-800 text-xs font-medium mb-5">
            <i className="ri-information-line" />
            关于香蕉社区
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 leading-tight text-balance">
            一个让分享更自在的多元社区
          </h2>
          <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
            香蕉社区是一个围绕多元交流互动展开的综合社区平台。我们相信，好的社区不是喧闹的广场，而是能让每个人都找到合适位置的地方。无论你热爱旅行、痴迷数码，还是想聊聊职场与生活，这里都为你留了一个位子。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-full bg-primary-500 hover:bg-primary-600 text-foreground-950 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-full border border-secondary-300 text-foreground-800 hover:bg-background-50 text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line" />
              联系我们
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {highlights.map((item) => (
            <div key={item.title} className="p-5 rounded-xl bg-background-50 border border-background-200/70">
              <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                <i className={`${item.icon} text-xl`} />
              </span>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{item.title}</h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}